import React from 'react';
import { Flex, IconButton, Input, InputGroup, InputRightElement } from '@chakra-ui/react';
import { BsSearch } from 'react-icons/bs';
import { SearchProps } from '../../../types/ui';
import { useSearch } from '../../../hooks/useSearch';

export default function CustomSearch({
    placeholder,
    searchValue, 
    onChange
}: SearchProps) {
    const { value, handleValueChange } = useSearch({ initialValue: searchValue, onChange })
    return (
        <Flex direction={'row'} align='center' justify='flex-end'>
            <InputGroup className="mr--10" borderRadius={'lg'}>
                <Input 
                    type='text' 
                    size="sm" 
                    placeholder={placeholder} 
                    defaultValue={value}
                    value={value}
                    onChange={handleValueChange}
                />
                <InputRightElement
                    className="h--100" 
                    children={
                        <IconButton 
                            variant={'ghost'} 
                            aria-label={placeholder} 
                            color='gray.400'
                            _hover={{ bg: 'transparent' }}
                            _focus={{ boxShadow: 'none', border: 'none', bg: 'transparent' }}
                            icon={<BsSearch />} 
                        />
                    } 
                />
            </InputGroup>
        </Flex>
    )
}